import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { InputLabel, MenuItem, FormControl, Select } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
  },
}))

const SelectBox = (props) => {
  const classes = useStyles()

  return (
    <FormControl required={props.required} margin="dense" variant="outlined" className={classes.formControl}>
      <InputLabel>{props.label}</InputLabel>
      <Select value={props.value} onChange={(event) => props.select(event.target.value)}>
        {props.options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectBox
